import React from 'react';


const Input = (props) => {
	//console.log(props.value);
	return (  
  <div className="form-group">
    <div className="row">

      <div className="col-md-1"></div>
      <div className="col-md-2 file-label"> 
       <label htmlFor={props.name} className="form-label">{props.title}</label>
      </div> 
      <div className="col-md-8">
        <div className="input-group">  
          <span className="input-group-addon">
            <i className={props.icon} aria-hidden="true"></i>
          </span>
          <input
            className="form-control1"
            id={props.name}
            name={props.name}
            type={props.inputType}
            value={props.value}
            onChange={props.handleChange}
            placeholder={props.placeholder} 
            {...props} />
        </div>    

      </div>
      <div className="col-md-1"></div>
     </div> 
  </div>
)
}

export default Input;